"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Revision = exports.Revisions = void 0;
const string_normalizer_1 = require("../util/string-normalizer");
class Revisions extends Array {
    constructor(...args) {
        super(...args);
        Object.setPrototypeOf(this, new.target.prototype);
    }
    static fromPlain(plain) {
        const rawRevisions = plain.map((plainRevision) => Revision.fromPlain(plainRevision));
        const revisions = new Revisions(...rawRevisions);
        return revisions;
    }
    toPlain() {
        return this.map((revision) => revision.toPlain());
    }
    resolve(name, ignoreOptions) {
        const outerThis = this;
        const resolveRec = function (currentName, beforeNames) {
            const normalizedCurrentName = string_normalizer_1.StringNormalizer.normalize(currentName, ignoreOptions);
            const revisions = outerThis.filter((revision) => {
                const normalizedBeforeName = string_normalizer_1.StringNormalizer.normalize(revision.beforeName, ignoreOptions);
                return normalizedBeforeName === normalizedCurrentName;
            });
            const resultNames = [];
            for (const revision of revisions) {
                if (beforeNames.includes(revision.afterName)) {
                }
                else {
                    const result = resolveRec(revision.afterName, [...beforeNames, revision.afterName]);
                    resultNames.push(revision.afterName, ...result);
                }
            }
            return resultNames;
        };
        const resultNames = resolveRec(name, [name]);
        return resultNames;
    }
}
exports.Revisions = Revisions;
class Revision {
    constructor(date, beforeName, afterName) {
        this.date = date;
        this.beforeName = beforeName;
        this.afterName = afterName;
    }
    static fromPlain(plain) {
        const date = plain.date;
        const beforeName = plain.beforeName;
        const afterName = plain.afterName;
        const revision = new Revision(date, beforeName, afterName);
        return revision;
    }
    toPlain() {
        return this;
    }
}
exports.Revision = Revision;
